import { marianistaInitInfraModal } from './infra-modal.js';
import { marianistaInitIpVidaLightbox } from './ip-vida-lightbox.js';
import { marianistaInitPrimGaleria } from './prim-galeria.js';
import { marianistaInitFaqAccordion } from './faq-accordion.js';
import { marianistaInitContactoVisitaModal } from './contacto-visita-modal.js';
import { marianistaInitEgRevistasModal } from './eg-revistas-modal.js';
import { marianistaInitEgFotosGallery } from './eg-fotos-gallery.js';

/**
 * Navegación móvil y Splide (hero)
 */
const navToggle = document.getElementById('nav-toggle');
const navMenu = document.getElementById('nav-menu');

const marianistaNavMobileMq = window.matchMedia('(max-width: 768px)');

function marianistaNavIsMobile() {
  return marianistaNavMobileMq.matches;
}

if (navToggle && navMenu) {
  navToggle.addEventListener('click', () => {
    navToggle.classList.toggle('activo');
    navMenu.classList.toggle('activo');
    if (!navMenu.classList.contains('activo')) {
      document.querySelectorAll('.nav__item--dropdown').forEach((item) => {
        item.classList.remove('activo');
        const btn = item.querySelector('.nav__dropdown-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.querySelectorAll('.nav__item--dropdown').forEach((item) => {
    const toggle = item.querySelector('.nav__dropdown-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!marianistaNavIsMobile()) return;
      const open = item.classList.toggle('activo');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
}

const heroEl = document.getElementById('hero-splide');
if (heroEl && typeof Splide !== 'undefined') {
  new Splide(heroEl, {
    type: 'fade',
    rewind: true,
    autoplay: true,
    interval: 6000,
    speed: 900,
    pauseOnHover: true,
    arrows: true,
    pagination: true,
    keyboard: true,
    lazyLoad: 'nearby',
  }).mount();
}

document.querySelectorAll('.ip-vida__splide').forEach((el) => {
  if (typeof Splide === 'undefined') {
    return;
  }
  new Splide(el, {
    type: 'carousel',
    perPage: 5,
    perMove: 1,
    gap: '1.6rem',
    pagination: true,
    arrows: false,
    drag: true,
    breakpoints: {
      1280: { perPage: 4, gap: '1.4rem' },
      1024: { perPage: 3, gap: '1.2rem' },
      768: { perPage: 2, gap: '1rem' },
      480: { perPage: 1, gap: '1rem' },
    },
  }).mount();
});

/**
 * WOW + Animate.css: solo en elementos DIV contenedores (fadeIn).
 * No se añaden clases a títulos, párrafos u otros nodos de texto.
 */
function marianistaInitWowFadeIn() {
  if (document.body.classList.contains('wp-admin')) {
    return;
  }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }
  if (typeof WOW === 'undefined') {
    return;
  }

  const selectors = [
    'section > div.contenedor',
    'section div.contenedor.hero-slide__body',
    'footer > div.contenedor',
    'header.post-hero > div.contenedor',
    '.post-featured__inner.contenedor',
    'article.post-body > div.contenedor',
  ];

  const seen = new Set();
  selectors.forEach((sel) => {
    document.querySelectorAll(sel).forEach((node) => {
      if (!(node instanceof HTMLDivElement)) {
        return;
      }
      if (seen.has(node)) {
        return;
      }
      seen.add(node);
      node.classList.add('wow', 'fadeIn');
    });
  });

  const wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 40,
    mobile: true,
    live: false,
  });
  wow.init();
}

function marianistaDomReady() {
  marianistaInitWowFadeIn();
  marianistaInitInfraModal();
  marianistaInitIpVidaLightbox();
  marianistaInitPrimGaleria();
  marianistaInitFaqAccordion();
  marianistaInitContactoVisitaModal();
  marianistaInitEgRevistasModal();
  marianistaInitEgFotosGallery();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', marianistaDomReady);
} else {
  marianistaDomReady();
}
